import styled from "styled-components";
import type { RuntimeTheme } from "webapp/lib/theme/core-themes/runtime-theme";
import { disabledProps } from "webapp/styled-components";

// FIXME: There has to be a better way to do mixins
function radialButtonStyle(theme: RuntimeTheme, active: boolean): string {
    return `
    width: 55px;
    height: 55px;
    border-radius: 1000px;

    color: ${active ? theme.baseColor : theme.primaryAccentColor};
    background-color: ${active ? theme.primaryAccentColor : theme.baseColor};
    border-color: ${theme.primaryAccentColor};
    border-width: 3px;
    border-style: solid;

    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    > input {
        position: absolute;
        width: 0;
        height: 0;
    }
    `;
}

function radialButtons(theme: RuntimeTheme) {
    return `
    & > .csc-radial-button-active {
        margin: 0 11px 11px 0;
        ${radialButtonStyle(theme, true)};
    }

    & > .csc-radial-button-inactive {
        margin: 0 11px 11px 0;
        ${radialButtonStyle(theme, false)};
    }

    & > .csc-radial-button-unavailable {
        margin: 0 11px 11px 0;
        ${disabledProps}
        ${radialButtonStyle(theme, false)};
    }`;
}

function bottomBarDirectionForLayout(orientation: "portrait" | "landscape" | undefined): "row" | "column" {
    return orientation === "landscape" ? "column" : "row";
}

export const CodeScannerWrapper = styled.div<{ orientation?: "portrait" | "landscape" }>`
    position: absolute;
    display: flex;
    flex-direction: ${p => (p.orientation === "landscape" ? "row" : "column")};
    height: 100%;
    width: 100%;
    overflow: hidden;

    & > #csc-scanner-container-container {
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        position: relative;

        & > canvas {
            width: 100%;
            height: 100%;
            object-fit: contain;
            pointer-events: none;
        }

        & > canvas.drawingBuffer {
            position: absolute;
        }
    }

    video {
        position: absolute;
        z-index: 5;
        width: 100%;
        height: 100%;
        display: none;
        object-fit: cover;

        pointer-events: none;
    }

    & > #csc-bottom-bar {
        position: relative;

        display: flex;
        flex-direction: ${p => (p.orientation === "landscape" ? "column-reverse" : "row")};
        align-items: center;
        justify-content: space-between;
        padding: 11px 0 var(--safe-area-inset-bottom) 11px;

        & > #csc-bottom-bar-left {
            display: flex;
            flex-direction: ${p => bottomBarDirectionForLayout(p.orientation)};
            justify-content: flex-start;

            ${p => radialButtons(p.theme)}
        }

        & > #csc-bottom-bar-right {
            display: flex;
            flex-direction: ${p => bottomBarDirectionForLayout(p.orientation)};
            justify-content: flex-end;

            ${p => radialButtons(p.theme)}
        }
    }
`;

function settingsPortraitMixin(height: number) {
    return `
    top: -${height - 1}px;
    left: 0;

    width: 100%;

    @keyframes csc-settings-showup-portrait {
        0% {
            opacity: 0;
            height: 0px;
            top: 0px;
        }
        100% {
            opacity: 1;
            height: ${height}px;
            top: -${height - 1}px;
        }
    }
`;
}

// Note that we have to use vw to get these particulars right for
// the settings overlay, which precludes this from functioning
// properly outside of a frameless player.
function settingsLandscapeMixin(height: number, width: number) {
    return `
    top: calc(100% - ${height - 1}px);
    right: ${width}px;

    width: calc(100vw - ${width}px);

    @keyframes csc-settings-showup-landscape {
        0% {
            opacity: 0;
            height: 0px;
            top: 100%;
        }
        100% {
            opacity: 1;
            height: ${height}px;
            top: calc(100% - ${height - 1}px);
        }
    }
`;
}

// Beware the background-color: we're assuming the color is a solid
// hex string and tacking on an alpha channel.
export const SettingsWrapper = styled.div<{ orientation: "portrait" | "landscape" }>`
    display: flex;
    flex-direction: column;
    position: absolute;
    justify-content: center;
    align-items: center;
    z-index: 10;

    background-color: ${p => p.theme.offBaseColor + "d0"};

    height: 175px;
    ${p => (p.orientation === "portrait" ? settingsPortraitMixin(175) : settingsLandscapeMixin(175, 77))}

    animation-duration: 125ms;
    animation-name: csc-settings-showup-${p => p.orientation};
    animation-timing-function: ease-out;
    animation-fill-mode: forwards;

    & > div {
        width: 375px;
    }

    & > div.close-button-container {
        height: 0;
        width: 100%;
        position: relative;

        & > button.close-button {
            position: absolute;
            top: 0;
            right: 0;

            border-radius: 11px;
            margin-right: 3px;
            background-color: ${p => p.theme.primaryAccentColor};

            & > div {
                height: 22px;
                width: 22px;
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }
    }
`;
